import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from '../app.settings';
import { MenuService } from 'src/services/menu.service';
import { MatDialog } from '@angular/material';
import { BroadcastMessageService } from 'src/services/broadcastMessageService';
import swal from 'sweetalert2';


@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
    @ViewChild('sidenav', { static: true }) sidenav: any;
    public toolbarTypes = [1, 2];
    public toolbarTypeOption: number;
    public headerTypes = ['default', 'image', 'carousel'];
    public headerTypeOption: string;
    public searchPanelVariants = [1, 2, 3];
    public searchPanelVariantOption: number;
    public headerFixed: boolean = false;
    public showBackToTop: boolean = false;
    public scrolledCount = 0;
    langId: any;
    //public menuItems: Array<Menu> = [];
    menuList: any;
    public settings: Settings;
    Height: number;
    width: any;
    leftSideBotwidth: number;
    constructor(public appSettings: AppSettings, public router: Router,
        public menuService: MenuService, public dialog: MatDialog) {
        this.settings = this.appSettings.settings;
    }

    ngOnInit() {
        this.langId = this.settings.langId;
        this.toolbarTypeOption = this.settings.toolbar;
        this.headerTypeOption = this.settings.header;
        this.searchPanelVariantOption = this.settings.searchPanelVariant;
        this.getVerticalMenuItems();
        this.Height = window.innerHeight;
        this.width = window.innerWidth;
        this.leftSideBotwidth = window.innerWidth;
        if(this.width > 500){
            this.width = '50%'
        }else{
            this.width = '370px'
        }
        this.Height = (this.Height - 100);
        // console.log(window.innerHeight);
        // this.openChatBot();
    }

    getVerticalMenuItems() {
        this.menuService.getVerticalMenuItems(true, this.langId).subscribe(result => {
            if (result != null && result != undefined) {
                this.menuList = result;
                // console.log(this.menuList);
            }
            // console.log(this.menuList);
        });
    }
    showChilds(index){
        this.menuList[index].active = !this.menuList[index].active;
        this.collapseAnother(index);
    };
    
    collapseAnother (index){
        for(var i=0; i<this.menuList.length; i++){
            if(i!=index){
                this.menuList[i].active = false;
            }
        }
    };
    public changeTheme(theme) {
        this.settings.theme = theme;
    }

    public chooseToolbarType() {
        this.settings.toolbar = this.toolbarTypeOption;
        window.scrollTo(0, 0);
    }

    public chooseHeaderType() {
        this.settings.header = this.headerTypeOption;
        window.scrollTo(0, 0);
        this.router.navigate(['/']);
    }

    public chooseSearchPanelVariant() {
        this.settings.searchPanelVariant = this.searchPanelVariantOption;
    }


    @HostListener('window:scroll') onWindowScroll() {
        const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
        (scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;

        if (this.settings.stickyMenuToolbar) {
            let top_toolbar = document.getElementById('top-toolbar');
            if (top_toolbar) {
                if (scrollTop >= top_toolbar.clientHeight) {
                    this.settings.mainToolbarFixed = true;
                }
                else {
                    this.settings.mainToolbarFixed = false;
                }
            }
        }

        debugger
        let load_more = document.getElementById('load-more');
        if (load_more) {
            if (window.innerHeight > load_more.getBoundingClientRect().top + 120) {
                if (!this.settings.loadMore.complete) {
                    if (this.settings.loadMore.start) {
                        if (this.scrolledCount < this.settings.loadMore.step) {
                            this.scrolledCount++;
                            if (!this.settings.loadMore.load) {
                                this.settings.loadMore.load = true;
                            }
                        }
                        else {
                            this.settings.loadMore.start = false;
                            this.scrolledCount = 0;
                        }
                    }
                }
            }
        }
    }

    public scrollToTop() {
        var scrollDuration = 200;
        var scrollStep = -window.pageYOffset / (scrollDuration / 20);
        var scrollInterval = setInterval(() => {
            if (window.pageYOffset != 0) {
                window.scrollBy(0, scrollStep);
            }
            else {
                clearInterval(scrollInterval);
            }
        }, 10);
        if (window.innerWidth <= 768) {
            setTimeout(() => { window.scrollTo(0, 0) });
        }
    }

    ngAfterViewInit() {
        document.getElementById('preloader').classList.add('hide');
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.sidenav.close();
                this.settings.mainToolbarFixed = false;
                setTimeout(() => {
                    window.scrollTo(0, 0);
                });
            }
        });
    }

    openChatDialog(menuTitle) {

    }
    openCovidDialog() {
        swal.fire({
            // title: "CHAT for Help",
            // text: "",
            showCancelButton: false,
            confirmButtonText: "Ok",
            text: "Coming Soon, Stay Tuned",
            // cancelButtonText: "",
            showCloseButton: true,
            imageUrl: 'assets/images/links/New_Chat_icon_HI.png', 
        }).then((result) => {
            if (result.value) {
                // window.open('http://78.46.86.133:8080/chatbot/', '_blank');
            }

        })
    }


    openChatBot() {
        swal.fire({
            title: "New India @ 75 Quiz Contest",
            text: "",
            showCancelButton: false,
            showConfirmButton: false,
            // confirmButtonText: "தமிழில் உரையாட",
            // cancelButtonText: "Chat in English",
            showCloseButton: true,
            imageUrl: 'assets/images/NewIndia-popup.png',
            // timer: 10000,
            allowOutsideClick: false,
            html: 
            `<div>
             <a href="https://quiz-newindiaat75.tnsacs.in/login" target="_blank" ><button class="btn sweetbtn ">Click Here</button></a>
            </div>`
            
        }).then((result) => {            
        })
    }


}
